import React from "react";

interface ListTableSectionProps<T> {
    title: string;
    headers: string[];
    rows?: T[] | null;
    rowKey: (row: T) => React.Key;
    renderRow: (row: T) => React.ReactNode;
}

export default function ListTableSection<T>({
                                                title,
                                                headers,
                                                rows,
                                                rowKey,
                                                renderRow,
                                            }: ListTableSectionProps<T>) {
    if (!rows?.length) return null;

    return (
        <>
            <p><strong>{title}:</strong></p>
            <table>
                <thead>
                <tr>
                    {headers.map(h => <th key={h}>{h}</th>)}
                </tr>
                </thead>
                <tbody>
                {rows.map(r => (
                    <tr key={rowKey(r)}>
                        {renderRow(r)}
                    </tr>
                ))}
                </tbody>
            </table>
        </>
    );
}